module.exports = __webpack_public_path__ + "img/index_help_cjwt@2x.2ebb15de.png";